import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled render error:', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        style={{
          minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', gap: 16, padding: 24, textAlign: 'center', background: '#0a0a10', color: '#c9c9d4',
        }}
      >
        <div style={{ fontSize: 15, fontWeight: 700, color: '#fff' }}>Something went wrong.</div>
        <div style={{ fontSize: 13, color: '#8b8b9c', maxWidth: 420 }}>
          This page hit an unexpected error. Reloading usually fixes it.
        </div>
        <button
          onClick={() => window.location.reload()}
          style={{
            background: 'linear-gradient(135deg,#ff6b5f,#ff3d31)', color: '#12060a', border: 'none',
            borderRadius: 9, padding: '10px 20px', fontWeight: 800, cursor: 'pointer',
          }}
        >
          Reload
        </button>
      </div>
    );
  }
}
